import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';

export function runApp() {
  const store = createApplicationState();
  const context = createContext();

  renderApplication({ store, context });
}
